module.exports = __webpack_public_path__ + "img/c00_buildingtechhandsaw_Normal_ua.64563ff0.webp";